import {
  SET_DATASET,
  SET_FREQUENCY_DATASET,
  SET_NAME_OF_DATASET,
  SET_TYPE_OF_DATASET,
  SET_NAME_OF_COLUMNS,
  RESET_DATASET,
  RESET_FREQUENCY_DATASET,
  SET_CORRECT_VAR_TYPES
} from './types';
import { RAW, CONTINGENCY } from 'scenes/Dataset/components/constants';

import { samplingDistributions } from 'mobx-store';
import {
  setSummary,
  getFrequencyDataSet,
  setSelectedParameters,
  resetSelectedParameters,
  getParametersFromDataSet,
  calculateRawDatasetSummary
} from 'store/dataset';
import { setSelectedStats } from '../../selectedStats';
import { resetSamplingDistributionsForm } from 'store/form/samplingDistributions/actions';
import { resetInferentialStatistics } from 'store/form/inferentialStatistics';
import { resetPageAndPagination, setErrorTypeOfUploadDataset } from 'store/scenes/dataSet';
import { destroyInferentialStatistics } from '../../form/inferentialStatistics';
import {
  getCalculateFrequencyDataSet,
  identifyTypeOfFrequencyDataSet,
  extractFreqColumnsAndCategoryCol,
  getCalculateFrequencyDatasetSummary
} from 'calculators/dataset/frequencyTable';
import { parseDatasetFile } from 'utilities';


export const setDataset = data => ({ type: SET_DATASET, data });
export const setNameOfDataset = nameOfDataset => ({ type: SET_NAME_OF_DATASET, nameOfDataset });
export const setTypeOfDataset = typeOfDataset => ({ type: SET_TYPE_OF_DATASET, typeOfDataset });
export const setNameOfColumns = nameOfColumns => ({ type: SET_NAME_OF_COLUMNS, nameOfColumns });

export const setFrequencyDataSet = frequencyDataSet => ({
  type: SET_FREQUENCY_DATASET, frequencyDataSet
});
export const setCorrectVarTypes = variableTypes => ({ type: SET_CORRECT_VAR_TYPES, variableTypes });

export const getResetDatasetAction = () => ({ type: RESET_DATASET });

export const resetFrequencyDataSet = () => ({ type: RESET_FREQUENCY_DATASET });

export const resetDataset = () => dispatch => {
  dispatch([
    resetSelectedParameters(),
    resetInferentialStatistics(),
    resetSamplingDistributionsForm(),
    resetPageAndPagination()
  ]);

  samplingDistributions.reset();

  dispatch({ type: RESET_DATASET });
};

/* Reset logic for the application */
const reset = dispatch => {
  const resetActions = [
    resetSelectedParameters(),
    resetPageAndPagination(),
    destroyInferentialStatistics(),
    resetSamplingDistributionsForm()
  ];
  dispatch(resetActions);
  samplingDistributions.reset();

  const dataResetActions = [getResetDatasetAction()];
  dispatch(dataResetActions);
};

export const setRawDataset = (dataSet, nameOfDataset) => (dispatch, getState) => {
  const state = getState();
  if (getFrequencyDataSet(state)) {
    dispatch(resetFrequencyDataSet());
  }
  dispatch(reset);

  dispatch(setDataset(dataSet));
  dispatch(setNameOfDataset(nameOfDataset));
  dispatch(setTypeOfDataset(RAW));
};

export const setRawDatasetState = (dataSet, nameOfDataset) => dispatch => {
  dispatch(setRawDataset(dataSet, nameOfDataset));

  const { selectedParams, correctTypes } = getParametersFromDataSet(dataSet);
  dispatch(setSelectedParameters(selectedParams));
  dispatch(setCorrectVarTypes(correctTypes));

  dispatch(calculateRawDatasetSummary());
  dispatch(setSelectedStats());
};

export const setFrequencyDatasetState = (frequencyDataset, frequencyDatasetType, frequencyColumnsName, nameOfDataset) => dispatch => {
  dispatch(reset);

  dispatch(setTypeOfDataset(frequencyDatasetType));
  dispatch(setNameOfDataset(nameOfDataset));
  dispatch(setNameOfColumns(frequencyColumnsName));

  const { categoryColumn } = extractFreqColumnsAndCategoryCol(frequencyDataset);

  // Turn Category Column values to string
  const parsedFrequencyDataset = frequencyDataset.map(item => {
    return {
      ...item,
      [categoryColumn]: `${item[categoryColumn]}`
    };
  });
  dispatch(setDataset(parsedFrequencyDataset));

  const calculatedFrequencyFromDataset = getCalculateFrequencyDataSet(parsedFrequencyDataset, frequencyColumnsName);
  dispatch(setFrequencyDataSet(calculatedFrequencyFromDataset));

  const summary = getCalculateFrequencyDatasetSummary(calculatedFrequencyFromDataset);
  dispatch(setSummary(summary));

  const { selectedParams } = getParametersFromDataSet(parsedFrequencyDataset);
  dispatch(setSelectedParameters(selectedParams));
};

export const setFileState = (file, tableType = RAW, showSelectedDatasetTab) => dispatch => {
  if (file) {
    const fileName = file.name.slice(0, file.name.lastIndexOf('.'));
    parseDatasetFile(file, parsedDataset => {
      if (tableType !== RAW) {
        const { status, type } = identifyTypeOfFrequencyDataSet(parsedDataset, tableType);
        if (status === 'error') {
          dispatch(setErrorTypeOfUploadDataset(true));
          return;
        }
        if (status === 'success') {
          reset(dispatch);
          dispatch(setErrorTypeOfUploadDataset(false));
          dispatch(setFrequencyDatasetState(parsedDataset, type, tableType === CONTINGENCY ? 'Category' : '', fileName));
        }
      } else {
        reset(dispatch);
        dispatch(setErrorTypeOfUploadDataset(false));
        dispatch(setRawDataset(parsedDataset, fileName));
      }
      showSelectedDatasetTab();
    });
  } else {
    dispatch(reset);
  }
};
